export enum conflictResolveType {
  conflict = 'conflict',
  localPreference = 'localPreference',
  remotePreference = 'remotePreference',
  keepBoth = 'keepBoth',
}

export type ConflictFileInfo = {
  path: string;
  size: number;
  mTime: string;
};

export type ConflictDataObj = {
  result: conflictResolveType;
  autoChoose: boolean;
  localItem: ConflictFileInfo;
  remoteItem: ConflictFileInfo;
};

export default class ConflictData {
  private result: conflictResolveType = conflictResolveType.conflict;
  private autoChoose = false;
  public localItem!: ConflictFileInfo;
  public remoteItem!: ConflictFileInfo;

  public toDataObj(): ConflictDataObj {
    return {
      result: this.result,
      autoChoose: this.autoChoose,
      localItem: this.localItem,
      remoteItem: this.remoteItem,
    };
  }

  public fromDataObj(data: ConflictDataObj) {
    this.result = data.result;
    this.autoChoose = data.autoChoose;
    this.localItem = data.localItem;
    this.remoteItem = data.remoteItem;
  }

  public chooseLocalPreference(autoChoose = false) {
    this.result = conflictResolveType.localPreference;
    this.autoChoose = autoChoose;
  }

  public chooseRemotePreference(autoChoose = false) {
    this.result = conflictResolveType.remotePreference;
    this.autoChoose = autoChoose;
  }

  public chooseKeepBoth(autoChoose = false) {
    this.result = conflictResolveType.keepBoth;
    this.autoChoose = autoChoose;
  }

  public setupConflictData(localItem: ConflictFileInfo, remoteItem: ConflictFileInfo) {
    this.result = conflictResolveType.conflict;
    this.autoChoose = false;
    this.localItem = localItem;
    this.remoteItem = remoteItem;
  }

  public isCurrentConflict(localPath: string, remotePath: string): boolean {
    return (
      localPath === this.localItem.path &&
      remotePath === this.remoteItem.path &&
      this.result !== conflictResolveType.conflict
    );
  }

  public getResolveResult(): conflictResolveType {
    return this.result;
  }
}
